module.exports = __webpack_public_path__ + "static/5-0508fbd741dcbb72f6444d4b03b3dab5.png";